import React, { useState, useEffect } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
import axios from 'axios';
import logo from "../../../assets/img/logo.png"
import '../../plugins/datatables/datatables.min.css';
import HitkariSidebar from '../Adminsidebar/AdminSidebar';


function Addblog() {
    const [activeLink, setActiveLink] = useState(null);

    const handleLinkClick = (link) => {
        setActiveLink(link);
    };
  const [isOpen, setIsOpen] = useState(false);


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

    const [formData, setFormData] = useState({
        subject: '',
        authorName: '',
        description: '',
        picture: null,
        url: '',
    });

    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [blogsPerPage, setBlogsPerPage] = useState(5); // Set blogsPerPage to be managed by state
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editingBlogId, setEditingBlogId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingBlog, setEditingBlog] = useState(null);
     const [searchTerm, setSearchTerm] = useState(''); // Add searchTerm state



    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL
    const DEFAULT_IMAGE = logo;

    useEffect(() => {
        fetchBlogs();
    }, []);

    useEffect(() => {
        // Initialize DataTables only when doctors are loaded and DataTables is available
        if (window.$ && blogs.length > 0 && !window.$.fn.dataTable.isDataTable('.datatable')) {
            setTimeout(() => {
                window.$('.datatable').DataTable();
            }, 500); // Delay to ensure table is rendered
        }
    }, [blogs]); // Re-run when blogs change



    const fetchBlogs = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/api/blogs`);
            setBlogs(response.data);
        } catch (err) {
            setError("Failed to fetch blogs.");
            console.error("Error fetching blogs:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, picture: e.target.files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.subject || !formData.authorName || !formData.description || !formData.picture) {
            alert('All fields except URL are required.');
            return;
        }
        setIsSubmitting(true);
        setSubmitSuccess(false);

        const blogData = new FormData();
        blogData.append('subject', formData.subject);
        blogData.append('authorName', formData.authorName);
        blogData.append('description', formData.description);
        blogData.append('url', formData.url);
        blogData.append('picture', formData.picture);

        try {
            const response = await axios.post(`${API_BASE_URL}/api/blogs/add`, blogData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            if (response.status === 201) {
                setSubmitSuccess(true);
                setTimeout(() => {
                    setSubmitSuccess(false);
                }, 3000);
                setFormData({ subject: '', authorName: '', description: '', picture: null, url: '' });
                fetchBlogs();
                setShowAddModal(false); // Close modal on success
            } else {
                alert('An error occurred while submitting your blog.');
            }
        } catch (error) {
            alert('An error occurred while submitting your blog.');
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditStart = (blog) => {
        setEditingBlogId(blog._id);
        setEditingBlog(blog);
        setShowEditModal(true);
        setFormData({
            subject: blog.subject,
            authorName: blog.authorName,
            description: blog.description,
            url: blog.url || '',
            picture: null
        });
    };
    const handleEditChange = (e) => {
        setEditingBlog({ ...editingBlog, [e.target.name]: e.target.value });
    };

    const handleEditCancel = () => {
        setEditingBlogId(null);
        setEditingBlog(null);
        setShowEditModal(false);
        setFormData({ subject: '', authorName: '', description: '', picture: null, url: '' });
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!editingBlog.subject || !editingBlog.authorName || !editingBlog.description) {
            alert('All fields except URL and image are required.');
            return;
        }
        setIsSubmitting(true);
        setSubmitSuccess(false);

        const formDataToSubmit = new FormData();
        formDataToSubmit.append('subject', editingBlog.subject);
        formDataToSubmit.append('authorName', editingBlog.authorName);
        formDataToSubmit.append('description', editingBlog.description);
        formDataToSubmit.append('url', editingBlog.url);
        if (formData.picture) {
            formDataToSubmit.append('picture', formData.picture);
        }

        try {
            const response = await axios.put(`${API_BASE_URL}/api/blogs/${editingBlogId}`, formDataToSubmit);
            if (response.status === 200) {
                setSubmitSuccess(true);
                setTimeout(() => {
                    setSubmitSuccess(false);
                }, 3000);
                setEditingBlogId(null);
                setEditingBlog(null);
                setShowEditModal(false);
                setFormData({ subject: '', authorName: '', description: '', picture: null, url: '' });
                fetchBlogs();
            } else {
                alert('An error occurred while updating the blog.');
            }
        } catch (error) {
            alert('An error occurred while updating the blog.');
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const deleteBlog = async (id) => {
        if (window.confirm("Are you sure you want to delete this blog?")) {
            try {
                await axios.delete(`${API_BASE_URL}/api/blogs/${id}`);
                setBlogs(blogs.filter((blog) => blog._id !== id));
                fetchBlogs(); // Refresh blogs after deletion
            } catch (error) {
                alert("Failed to delete blog.");
                console.error(error);
            }
        }
    };
    // Calculate blogs after search
    const searchedBlogs = blogs.filter(blog =>
            blog.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
            blog.authorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            blog.description.toLowerCase().includes(searchTerm.toLowerCase())
        );

    // Calculate blogs for current page
    const paginateBlogs = searchedBlogs.slice(
        (currentPage - 1) * blogsPerPage,
        currentPage * blogsPerPage
    );
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
     // Handler to change the number of blogs per page
    const handleBlogsPerPageChange = (e) => {
        const newBlogsPerPage = parseInt(e.target.value, 10);
        setBlogsPerPage(newBlogsPerPage);
        setCurrentPage(1); // Reset to first page when changing blogs per page
    };

     const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const totalPages = Math.ceil(searchedBlogs.length / blogsPerPage);

    const handleShowAddModal = () => {
        setShowAddModal(true);
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setFormData({ subject: '', authorName: '', description: '', picture: null, url: '' });
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
        <div className="main-wrapper">
            <div className="hitkari-main-wrapper">
     
           <HitkariSidebar/>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">Blogs</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/dash">Dashboard</a></li>
                                    <li className="breadcrumb-item active">Blogs</li>
                                </ul>
                            </div>
                            <div className="col-auto">
                                <button type="button" className="btn btn-primary" onClick={handleShowAddModal}>
                                    <i className="fas fa-plus"></i> Add Blog
                                </button>
                            </div>
                        </div>
                    </div>

                    {submitSuccess && (
                        <div className="alert alert-success">
                            Blog submitted successfully!
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                     {/* Search Input */}
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search blogs..."
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                                {/* Pagination */}
                          <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                                    <div>
                                        <label>Blogs per page:</label>
                                        <select
                                            className="form-control"
                                            value={blogsPerPage}
                                            onChange={handleBlogsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                        </select>
                                    </div>
                                    <nav aria-label="Blog pagination">
                                        <ul className="pagination justify-content-center">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} tabIndex="-1">Previous</button>
                                            </li>
                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                
                                        </div>
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : error ? (
                                        <p>{error}</p>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="datatable table table-hover table-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Author</th>
                                                        <th>Description</th>
                                                        <th>Image</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginateBlogs.map((blog) => {
                                                        const blogImage = blog.picture ? `${API_BASE_URL}/blog/${blog.picture}` : DEFAULT_IMAGE;
                                                        return (

                                                            <tr key={blog._id}>
                                                                <td>{blog.subject}</td>
                                                                <td>{blog.authorName}</td>
                                                                <td>{blog.description.substring(0, 50)}...</td>
                                                                <td>
                                                                    {blog.picture && (
                                                                        <img
                                                                            src={blogImage}
                                                                            alt={blog.subject}
                                                                            style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                                            onError={(e) => e.target.src = DEFAULT_IMAGE}
                                                                        />
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-primary mr-1" onClick={() => handleEditStart(blog)}>
                                                                        Edit
                                                                    </button>
                                                                    <button className="btn btn-sm btn-danger" onClick={() => deleteBlog(blog._id)}>
                                                                        Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    
                            </div>
                </div>

                {/* Edit Blog Modal */}
                {showEditModal && editingBlog && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editModalLabel">Edit Blog</h5>
                                    <button type="button" className="close" onClick={handleEditCancel} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleEditSubmit}>
                                        <div className="form-group">
                                            <label htmlFor="editSubject">Title</label>
                                            <input type="text" className="form-control" id="editSubject" name="subject" value={editingBlog.subject || ''} onChange={handleEditChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="editAuthorName">Author</label>
                                            <input type="text" className="form-control" id="editAuthorName" name="authorName" value={editingBlog.authorName || ''} onChange={handleEditChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="editDescription">Description</label>
                                            <textarea className="form-control" id="editDescription" name="description" rows="3" value={editingBlog.description || ''} onChange={handleEditChange}></textarea>
                                        </div>
                                        <button type="submit" className="btn btn-success">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Add Blog Modal */}
                {showAddModal && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="addModalLabel">Add New Blog</h5>
                                    <button type="button" className="close" onClick={handleCloseAddModal} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <label htmlFor="subject">Title</label>
                                            <input type="text" className="form-control" id="subject" name="subject" value={formData.subject} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="authorName">Author</label>
                                            <input type="text" className="form-control" id="authorName" name="authorName" value={formData.authorName} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="description">Description</label>
                                            <textarea className="form-control" id="description" name="description" rows="3" value={formData.description} onChange={handleChange}></textarea>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="picture">Picture</label>
                                            <input type="file" className="form-control" id="picture" name="picture" onChange={handleFileChange} />
                                        </div>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
        </div>
        </>
    );
}

export default Addblog;